var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconUml(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFF09E"
    },
    d: "M377.519,217.361H134.48c-11.128,0-20.148-9.02-20.148-20.148V36.999 c0-11.128,9.02-20.148,20.148-20.148h243.039c11.128,0,20.148,9.02,20.148,20.148v160.213 C397.667,208.339,388.646,217.361,377.519,217.361z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M377.52,233.598H134.48c-20.062,0-36.386-16.324-36.386-36.386V36.999 c0-20.062,16.322-36.386,36.386-36.386h243.039c20.062,0,36.384,16.324,36.384,36.386v160.213 C413.904,217.275,397.582,233.598,377.52,233.598z M134.48,33.089c-2.156,0-3.91,1.754-3.91,3.91v160.213 c0,2.156,1.754,3.91,3.91,3.91h243.039c2.155,0,3.908-1.754,3.908-3.91V36.999c0-2.156-1.754-3.91-3.908-3.91 C377.519,33.089,134.48,33.089,134.48,33.089z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M452.471,416.673c-8.967,0-16.238-7.271-16.238-16.238v-72.248c0-8.504-6.921-15.423-15.424-15.423 H91.19c-8.504,0-15.424,6.919-15.424,15.423v72.248c0,8.966-7.27,16.238-16.238,16.238s-16.238-7.271-16.238-16.238v-72.248 c0-26.412,21.487-47.898,47.9-47.898h329.619c26.412,0,47.9,21.486,47.9,47.898v72.248 C468.708,409.403,461.437,416.673,452.471,416.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M256,364.718c-8.968,0-16.238-7.271-16.238-16.238v-131.12c0-8.967,7.27-16.238,16.238-16.238 c8.967,0,16.238,7.271,16.238,16.238v131.12C272.238,357.449,264.967,364.718,256,364.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M59.529,511.386C26.705,511.386,0,484.682,0,451.857s26.705-59.528,59.529-59.528 s59.529,26.703,59.529,59.528S92.352,511.386,59.529,511.386z M59.529,424.805c-14.918,0-27.054,12.136-27.054,27.052 c0,14.916,12.136,27.054,27.054,27.054s27.054-12.138,27.054-27.054C86.583,436.941,74.445,424.805,59.529,424.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M299.292,511.386h-86.583c-8.968,0-16.238-7.271-16.238-16.238v-86.581 c0-8.967,7.27-16.238,16.238-16.238h86.583c8.967,0,16.238,7.271,16.238,16.238s-7.271,16.238-16.238,16.238h-70.345v54.106h54.108 V456.73c0-8.967,7.271-16.238,16.238-16.238c8.967,0,16.238,7.271,16.238,16.238v38.419 C315.529,504.117,308.258,511.386,299.292,511.386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M452.471,511.386c-32.825,0-59.529-26.705-59.529-59.529s26.705-59.528,59.529-59.528 S512,419.032,512,451.857S485.295,511.386,452.471,511.386z M452.471,424.805c-14.918,0-27.054,12.136-27.054,27.052 c0,14.916,12.138,27.054,27.054,27.054c14.916,0,27.054-12.138,27.054-27.054C479.524,436.941,467.387,424.805,452.471,424.805z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M212.708,472.968H102.819c-8.968,0-16.238-7.271-16.238-16.238c0-8.966,7.27-16.238,16.238-16.238 h109.889c8.968,0,16.238,7.271,16.238,16.238C228.946,465.696,221.677,472.968,212.708,472.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#507C5C"
    },
    d: "M353.963,472.968h-54.671c-8.966,0-16.238-7.271-16.238-16.238c0-8.966,7.271-16.238,16.238-16.238 h54.671c8.966,0,16.238,7.271,16.238,16.238C370.2,465.696,362.929,472.968,353.963,472.968z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUml);
export default __webpack_public_path__ + "static/media/icon-UML.c1ab8c265c107c4b829f0a66c9aa26ff.svg";
export { ForwardRef as ReactComponent };